<template>
  <widget-template :scroll="false">
    <v-layout row wrap class="smallWidgetLayout" fill-height>
      <v-flex xs4 align-center justify-center d-flex>
        <v-icon color="brown" class="widgetIcon">mdi-car-sports</v-icon>
      </v-flex>
      <v-flex xs8 d-flex>
        <v-layout column justify-end>
          <v-flex class="widgetHeader" d-flex justify-end>Pending Motor</v-flex>
          <v-flex :class="widgetTextStyle(pendingMtr.noQuote)" d-flex justify-end>
            {{animatedNumber}}
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="widgetInfoPnl">
        <v-divider></v-divider>
        <v-layout row wrap class="widgetInfo grey--text" align-center>
          <v-spacer></v-spacer>
          <div v-if="initState === 0">
            <!-- <v-tooltip top>
              <span slot="activator">
                <v-icon small color="orange">mdi-record</v-icon>
                Loading...
              </span>
              <span>Loading</span>
            </v-tooltip> -->
          </div>
          <div v-else-if="initState === 1">
            <!-- <v-tooltip top>
              <div slot="activator" @click="doReload" class="widgetAction">
                Updated {{lastUpdated}} ago
              </div>
              <span>Click to update</span>
            </v-tooltip> -->
          </div>
          <div v-else>
            <v-tooltip top>
              <div slot="activator" @click="doReload" class="widgetAction">
                <v-icon small color="red">mdi-record</v-icon>
                Error
              </div>
              <span>Click to retry</span>
            </v-tooltip>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </widget-template>
</template>

<script>
import { mapActions } from 'vuex'
import { formatDisplayTimeDistance } from '@/utils/date'
import { widgetMixin } from '../widgetMixin'
import { TweenLite } from 'gsap/TweenMax'

export default {
  data() {
    return {
      tweenedNumber: 0
    }
  },
  watch: {
    'pendingMtr.noQuote': function (newValue) {
      this.doAnimateNumber(newValue)
    }
  },
  computed: {
    pendingMtr() {
      return this.$store.state.widgets.pendingMtr
    },
    initState() {
      return this.pendingMtr.init
    },
    lastUpdated() {
      return formatDisplayTimeDistance(this.pendingMtr.lastUpdated, this.timeNow)
    },
    animatedNumber() {
      return this.tweenedNumber.toFixed(0)
    }
  },
  methods: {
    ...mapActions([
      'initPendingMtr'
    ]),
    doReload() {
      this.initPendingMtr()
    },
    doAnimateNumber(newValue) {
      TweenLite.to(this.$data, 0.5, { tweenedNumber: newValue })
    }
  },
  mounted() {
    this.doAnimateNumber(this.pendingMtr.noQuote)
    this.doReload()
  },
  mixins: [
    widgetMixin(true)
  ]
}
</script>

<style lang="scss" scoped>
</style>
